import {
  showLegacySubPageSelector,
  userIsLoggedInSelector,
  userProfileResolvedSelector,
} from "@/redux/user/userSlice";
import { useSelector } from "react-redux";

import LegacySubscriptionPage from "./LegacySubscriptionPage";
import UltimateSubscriptionPage from "./UltimateSubscriptionPage";

/**
 * /subscription, in two versions.
 *
 * A legacy subscriber on a still-active old tier keeps the pre-credits
 * three-tier page, exactly as it was; everyone else gets the single-plan page
 * built around credits. This component is the only thing that knows both pages
 * exist.
 *
 * The answer comes from users/profile, and until it lands a logged-in
 * visitor's is unknown — rendering the wrong pricing page and swapping it out
 * from under them is worse than a beat of nothing. Logged-out visitors are
 * never legacy, so they never wait.
 */
const Subscription = () => {
  const showOld = useSelector(showLegacySubPageSelector);
  const isLoggedIn = useSelector(userIsLoggedInSelector);
  const profileResolved = useSelector(userProfileResolvedSelector);

  if (isLoggedIn && !profileResolved) return null;

  return showOld ? <LegacySubscriptionPage /> : <UltimateSubscriptionPage />;
};

export default Subscription;
